var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"inner-content"},[_c('div',{staticClass:"label main_color_text"},[_vm._v("\n      Annexe\n    ")]),_c('sectionLexiqueCarte')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }